export const loadSchema = (schema) => ({
  type: "LOAD_SYPI_SCHEMA",
  schema: schema,
});

export const loadInitialSchema = (initialSchema) => ({
  type: "LOAD_INITIAL_CLIENT_SYPI_MASTER_SCHEMA",
  initialSchema: initialSchema,
});

export const loadMasterSchema = (masterSchema, rawMasterSchema) => ({
  type: "LOAD_SYPI_MASTER_SCHEMA",
  masterSchema: masterSchema,
  rawMasterSchema: rawMasterSchema,
});

export const setSypiDetails = (sypiObject, shouldUpdateInitial = true) => ({
  type: "SET_SYPI_DETAILS",
  sypiDetails: sypiObject,
  shouldUpdateInitial: shouldUpdateInitial,
});

export const addSchemaDefaultsToChanges = (sypiObject) => ({
  type: "ADD_SCHEMA_DEFAULTS",
  sypiDetails: sypiObject,
});

export const setFieldVisibility = (fieldVisibility) => ({
  type: "SET_FIELD_VISIBILITY",
  fieldVisibility: fieldVisibility,
});

export const setRehydrate = (rehydrate) => ({
  type: "SET_REHYDRATE",
  rehydrate: rehydrate,
});

export const updateSypiDetails = () => ({
  type: "UPDATE_SYPI_DETAILS",
});

export const loadDefaultConfig = (defaultConfig) => ({
  type: "LOAD_DEFAULT_CONFIG",
  defaultConfig: defaultConfig,
});

export const mergeDefaultConfig = (mergedConfig) => ({
  type: "MERGE_DEFAULT_CONFIG",
  mergedConfig: mergedConfig,
});

export const setSypiServerSettings = (sypiServerSettings) => ({
  type: "SET_SYPI_SERVER_SETTINGS",
  sypiServerSettings: sypiServerSettings,
});

export const setFeature = (featureObject) => ({
  type: "SET_FEATURE",
  features: featureObject,
});

export const setContent = (contentObject) => ({
  type: "SET_CONTENT",
  content: contentObject,
});

export const setBusinessRules = (businessRulesObject) => ({
  type: "SET_BUSINESS_RULES",
  businessRules: businessRulesObject,
});

export const setInstance = (instanceObject) => ({
  type: "SET_INSTANCE",
  instance: instanceObject,
});

export const setStyleConfig = (styleObject) => ({
  type: "SET_STYLE_CONFIG",
  styleConfig: styleObject,
});

export const setEntireConfig = (configObject) => ({
  type: "SET_ENTIRE_CONFIG",
  config: configObject,
});

export const toggleSummaryModal = (modalState) => ({
  type: "TOGGLE_SUMMARY_MODAL",
  modalState: modalState,
});

export const setSypiSectionSummaryName = (sypiSectionSummaryName) => ({
  type: "SET_SYPI_SECTION_SUMMARY_NAME",
  sypiSectionSummaryName: sypiSectionSummaryName,
});

export const toggleDarkMode = (darkModeOn) => ({
  type: "TOGGLE_DARK_MODE",
  darkModeOn: darkModeOn,
});

export const selectActionTab = (actionTab) => ({
  type: "SELECT_ACTION_TAB",
  actionTab: actionTab,
});

export const loadMaintenanceModeDetails = (maintenanceModeDetails) => ({
  type: "LOAD_MAINTENANCE_MODE_DETAILS",
  maintenanceModeDetails: maintenanceModeDetails,
});

export const loadMaintenanceModeDefaultMessaging = (
  maintenanceModeMessaging
) => ({
  type: "LOAD_MAINTENANCE_MODE_DEFAULT_MESSAGING",
  maintenanceModeMessaging: maintenanceModeMessaging,
});

export const loadMaintenanceModeClients = (maintenanceModeClients) => ({
  type: "LOAD_MAINTENANCE_MODE_CLIENTS",
  ctids: maintenanceModeClients,
});

export const setShowMaintenanceMode = (displayMaintenanceMode) => ({
  type: "SET_MAINTENANCE_MODE_DISPLAY",
  displayMaintenanceMode: displayMaintenanceMode,
});

export const resetMaintenanceModeAfterCancel = () => ({
  type: "RESET_MAINTENANCE_MODE_AFTER_CANCEL",
});

export const loadScheduledDraftSet = (scheduleDraftSet) => ({
  type: "LOAD_SCHEDULED_DRAFT_SET",
  scheduleDraftSet: scheduleDraftSet,
});

export const loadScheduledDraft = (scheduleDraft) => ({
  type: "LOAD_SCHEDULED_DRAFT",
  scheduleDraft: scheduleDraft,
});

export const loadInitialScheduledDraft = (initialScheduleDraft) => ({
  type: "LOAD_INITIAL_SCHEDULED_DRAFT",
  initialScheduleDraft: initialScheduleDraft,
});

export const loadHistorySet = (historySet, totalPages, pageNumber) => ({
  type: "LOAD_CONFIG_SCHEDULER_HISTORY",
  historySet: historySet,
  totalPages: totalPages,
  pageNumber: pageNumber,
});

export const loadSummaryChangesReview = (
  summaryView,
  importedConfig = null
) => ({
  type: "LOAD_SUMMARY_CHANGES_REVIEW",
  summaryView: summaryView,
  importedConfig: importedConfig,
});

export const loadGeneralSummaryPreview = (generalSummary) => ({
  type: "LOAD_GENERAL_SUMMARY_PREVIEW",
  generalSummary: generalSummary,
});

export const loadSypiSectionPreview = (
  sypiSectionConfigs,
  sypiSection,
  ctid,
  activeReleaseVersion,
  importedCTID,
  importedReleaseVersion,
  status
) => ({
  type: "LOAD_SYPI_SECTION_PREVIEW",
  sypiSectionConfigs: sypiSectionConfigs,
  sypiSection: sypiSection,
  ctid: ctid,
  activeReleaseVersion: activeReleaseVersion,
  importedCTID: importedCTID,
  importedReleaseVersion: importedReleaseVersion,
  status: status,
});

export const clearPreview = () => ({
  type: "CLEAR_PREVIEW",
});

export const setScheduledHistoryView = (
  scheduledHistoryView,
  shouldReset = false
) => ({
  type: "SET_SCHEDULED_HISTORY_VIEW",
  scheduledHistoryView: scheduledHistoryView,
  shouldReset: shouldReset,
});

export const setSypiConfigName = (sypiConfigName) => ({
  type: "SET_SYPI_CONFIG_NAME",
  sypiConfigName: sypiConfigName,
});

export const setSypiConfigStatus = (status) => ({
  type: "SET_SYPI_CONFIG_STATUS",
  status: status,
});

export const toggleSummaryConfirm = (disableConfirmCallback) => ({
  type: "TOGGLE_SUMMARY_CONFIRM",
  disableConfirmCallback: disableConfirmCallback,
});

export const setSypiConfigSaveState = (sypiConfigSaveState) => ({
  type: "SET_SYPI_CONFIG_SAVE_STATE",
  sypiConfigSaveState: sypiConfigSaveState,
});

export const setConfigViewStatusSet = (configViewStatusSet) => ({
  type: "SET_CONFIG_VIEW_STATUS_SET",
  configViewStatusSet: configViewStatusSet,
});

export const setSummaryViewType = (summaryViewType) => ({
  type: "SET_SUMMARY_VIEW_TYPE",
  summaryViewType: summaryViewType,
});

export const resetSypiSchedulerSetUp = () => ({
  type: "RESET_SYPI_SCHEDULER_SET_UP",
});

export const enableSummaryPostAction = (enablePost) => ({
  type: "ENABLE_SUMMARY_POST",
  enablePost: enablePost,
});

export const setFMLink = (fmLink) => ({
  type: "SET_FM_LINK",
  fmLink: fmLink,
});

export const removeFMLink = (fmLink) => ({
  type: "REMOVE_FM_LINK",
  fmLink: fmLink,
});

export const clearFMLinks = () => ({
  type: "CLEAR_FM_LINKS",
});

export const setFMLinkBucket = (fmLinkBucket) => ({
  type: "SET_FM_LINK_BUCKET",
  fmLinkBucket: fmLinkBucket,
});

export const setFMLinkEditingMode = (fmLinkEditingMode) => ({
  type: "SET_FM_LINK_EDITING_MODE",
  fmLinkEditingMode: fmLinkEditingMode,
});

export const setFMLinkList = (fmLinkList) => ({
  type: "SET_FM_LINK_LIST",
  fmLinkList: fmLinkList,
});

export const loadReleaseVersions = (releaseVersions) => ({
  type: "LOAD_RELEASE_VERSIONS",
  releaseVersions: releaseVersions,
});

export const setReleaseVersion = (release_version) => ({
  type: "SET_RELEASE_VERSION",
  release_version: release_version,
});

export const setInitialReleaseVersion = (release_version) => ({
  type: "SET_INITIAL_RELEASE_VERSION",
  release_version: release_version,
});

export const setDefaultReleaseVersion = (release_version) => ({
  type: "SET_DEFAULT_RELEASE_VERSION",
  release_version: release_version,
});

export const clearSypiS3 = () => ({
  type: "CLEAR_SYPI_S3",
});

export const isScheduleChanges = (isScheduleChanges) => ({
  type: "SET_SCHEDULE_CHANGES",
  isScheduleChanges: isScheduleChanges,
});

export const clearOtherConfigs = () => ({
  type: "CLEAR_OTHER_CONFIGS",
});

export const loadNewDefaultsPreview = (releaseVersion, newDefaultsSummary) => ({
  type: "LOAD_NEW_DEFAULTS_PREVIEW",
  releaseVersion: releaseVersion,
  newDefaultsSummary: newDefaultsSummary,
});

export const includeSchemaDefaults = (
  releaseVersion,
  includeSchemaDefaults
) => ({
  type: "INCLUDE_SCHEMA_DEFAULTS",
  releaseVersion: releaseVersion,
  includeSchemaDefaults: includeSchemaDefaults,
});

export const loadImportedInputs = (importedChanges) => ({
  type: "LOAD_IMPORTED_INPUTS",
  importedChanges: importedChanges,
});

export const setSelectedReleaseVersions = (release_versions) => ({
  type: "SET_SELECTED_RELEASE_VERSIONS",
  release_versions: release_versions,
});

export const setSelectedPreviewTab = (tab) => ({
  type: "SET_SELECTED_TAB",
  selectedTab: tab,
});

export const resetSypiConfig = () => ({
  type: "RESET_SYPI_CONFIG",
});
